import { Vector2, Color, ShaderMaterial } from 'three';
import Sizes from '../utils/Sizes.js';
import vertexShader from '../shaders/postprocess-background/vertex.glsl';
import fragmentShader from '../shaders/postprocess-background/fragment.glsl';

export default class BackgroundPostProcess {
    constructor() {
        // Setup
        this.sizes = Sizes.getInstance();
        this.initParams();
        this.initEffectMaterial();
        
        // Listen for resize events
        this.sizes.on('resize', this.onResize.bind(this));
        
        // Set initial overlay state
        this.updateOverlayState();
    }

    initParams() {
        this.params = {
            uResolution: new Vector2(this.sizes.width, this.sizes.height),
            uTime: 0.0,
            uBgColor: new Color(0.0, 0.0, 0.0),
            uOpacity: .8,
            uVignetteFrom: 0.65,
            uVignetteTo: 1.3,
            uVignetteAspect: new Vector2(0.86, 1.24),
            uVignetteColor: new Color(0.0, 0.0, 0.0),
            uSaturation: 0.0,
            uContrast: 0.0,
            uBrightness: 0.0,
            uTintColor: new Color(0.0, 0.0, 0.0),
            uTintOpacity: 0.0,
            uDitherSeed: 893.8508,
            uDebugAlpha: 0.0,
            uVignetteOpacity: 0.96,
            uOverlay: 0.0,
            uOverlayColor: new Color(0x0C0020)
        };
    }

    initEffectMaterial() {
        this.effectMaterial = new ShaderMaterial({
            uniforms: {
                tDiffuse: { value: null },
                uResolution: { value: this.params.uResolution },
                uBgColor: { value: this.params.uBgColor },
                uOpacity: { value: this.params.uOpacity },
                uVignetteFrom: { value: this.params.uVignetteFrom },
                uVignetteTo: { value: this.params.uVignetteTo },
                uVignetteAspect: { value: this.params.uVignetteAspect },
                uVignetteColor: { value: this.params.uVignetteColor },
                uSaturation: { value: this.params.uSaturation },
                uContrast: { value: this.params.uContrast },
                uBrightness: { value: this.params.uBrightness },
                uTintColor: { value: this.params.uTintColor },
                uTintOpacity: { value: this.params.uTintOpacity },
                uDitherSeed: { value: this.params.uDitherSeed },
                uDebugAlpha: { value: this.params.uDebugAlpha },
                uTime: { value: this.params.uTime },
                uVignetteOpacity: { value: this.params.uVignetteOpacity },
                uOverlay: { value: this.params.uOverlay },
                uOverlayColor: { value: this.params.uOverlayColor }
            },
            vertexShader,
            fragmentShader
        });
    }

    update(delta) {
        if (this.effectMaterial) {
            this.params.uTime += delta;
            this.effectMaterial.uniforms.uTime.value = this.params.uTime;
        }
    }

    getMaterial() {
        return this.effectMaterial;
    }

    updateOverlayState() {
        const isSmallScreen = this.sizes.width < 768; // Using same breakpoint as Phone.js
        this.params.uOverlay = isSmallScreen ? 0.0 : 1.0;
        this.effectMaterial.uniforms.uOverlay.value = this.params.uOverlay;
    }

    onResize() {
        // Update resolution
        this.params.uResolution.set(this.sizes.width, this.sizes.height);
        this.effectMaterial.uniforms.uResolution.value = this.params.uResolution;
        
        // Update overlay state
        this.updateOverlayState();
    }
}
